<ng-container *ngIf="appModeService.isApp(); else webProductsView">
  <section class="app-products-view">
    <header class="app-products-header">
      <h1>{{ 'APP.PRODUCTS_TITLE' | translate }}</h1>
    </header>

    <div class="app-search-row">
      <div class="app-search-box">
        <span class="pi pi-search"></span>
        <input type="text" [placeholder]="'APP.SEARCH_PLACEHOLDER' | translate" />
        <button type="button" class="app-filter-btn" (click)="openMobileFilter(); $event.stopPropagation()">
          <span>{{ 'APP.FILTER' | translate }}</span>
          <i class="pi pi-sliders-h"></i>
        </button>
      </div>
    </div>

    <div class="app-products-meta">
      <p>{{ products.length }} {{ 'APP.ITEMS' | translate }}</p>
    </div>

    <div class="app-products-grid">
      <article
        class="app-product-item"
        *ngFor="let item of products; trackBy: trackByProduct"
      >
        <div (click)="ViewProduct(item.id)" class="product-wrapper h-100">
          <app-product-card [data]="item" [appMode]="true"></app-product-card>
        </div>
      </article>
    </div>

    <div class="app-filter-modal" *ngIf="isMobileFilterOpen">
      <div class="app-filter-overlay" (click)="closeMobileFilter()"></div>

      <section class="app-filter-sheet" (click)="$event.stopPropagation()">
        <header class="app-filter-sheet-header">
          <h2>{{ 'APP.FILTER_AND_SORT' | translate }}</h2>
          <button type="button" class="app-filter-close-btn" (click)="closeMobileFilter()">
            <i class="pi pi-times"></i>
          </button>
        </header>

        <div class="app-filter-content">
          <div class="app-filter-group">
            <h3>{{ 'SORT_BY' | translate }}</h3>
            <div class="app-filter-select-wrap">
              <select [(ngModel)]="selectedSort">
                <option *ngFor="let option of sortOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <i class="pi pi-angle-right"></i>
            </div>
          </div>

          <div class="app-filter-group">
            <h3>{{ 'TYPE' | translate }}</h3>
            <div class="app-check-grid">
              <button
                type="button"
                class="app-check-item"
                *ngFor="let category of categories"
                [class.active]="selectedCategory === category.name"
                (click)="selectedCategory = selectedCategory === category.name ? '' : category.name"
              >
                <span class="box"></span>
                <span class="label">{{ category.name }}</span>
              </button>
            </div>
          </div>

          <div class="app-filter-group">
            <h3>{{ 'COLOR' | translate }}</h3>
            <div class="app-color-grid">
              <button
                type="button"
                class="app-color-box"
                *ngFor="let color of colors"
                [ngStyle]="{ background: color }"
                [class.active]="selectedColors.includes(color)"
                [attr.aria-label]="'Toggle color ' + color"
                (click)="toggleColor(color)"
              ></button>
            </div>
          </div>

          <div class="app-filter-group">
            <h3>{{ 'SIZE' | translate }}</h3>
            <div class="app-check-grid">
              <button
                type="button"
                class="app-check-item"
                *ngFor="let size of sizes"
                [class.active]="selectedSizes.includes(size)"
                (click)="toggleSize(size)"
              >
                <span class="box"></span>
                <span class="label">{{ size }}</span>
              </button>
            </div>
          </div>
        </div>

        <footer class="app-filter-actions">
          <button type="button" class="apply-btn" (click)="applyMobileFilters()">{{ 'APP.APPLY' | translate }}</button>
          <button type="button" class="clear-btn" (click)="clearMobileFilters()">{{ 'APP.CLEAR' | translate }}</button>
        </footer>
      </section>
    </div>
  </section>
</ng-container>

<ng-template #webProductsView>
  <div class="container py-5">
    <h1 class="main-title">{{ 'PRODUCTS' | translate }}</h1>

    <div class="row">
      <div class="col-12 col-md-4 col-lg-3 mb-4">
        <app-filter (filtersChanged)="applyFilters($event)"></app-filter>
      </div>

      <div class="col-12 col-md-8 col-lg-9">
        <div class="row gy-4">
          <div
            class="col-12 col-sm-6 col-lg-4"
            *ngFor="let item of products; trackBy: trackByProduct"
          >
            <div (click)="ViewProduct(item.id)" class="product-wrapper h-100">
              <app-product-card [data]="item"></app-product-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
